/* unplugin-vue-components disabled */import script from "./NavComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavComponent.vue?vue&type=script&lang=ts&setup=true"

import "./NavComponent.vue?vue&type=style&index=0&id=7be32e9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be32e9b"]])

export default __exports__